import { useTranslation } from "react-i18next";
import { SettingsSection } from "./settingSection.component";
import { NumberSettingInput } from "./numberSettingInput.component";

export const TimeReportDeviationThresholdSetting: React.FC<{
  value: number;
  onChange: (v: number) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <SettingsSection
      title={t("System.TimeReportDeviationThreshold")}
      info={t("System.TimeReportDeviationThresholdInfo")}
    >
      <NumberSettingInput
        label={t("System.TimeReportDeviationThreshold")}
        value={value}
        onChange={onChange}
      />
    </SettingsSection>
  );
};
